export default __webpack_public_path__ + "media/images/logo-symbol-icon-6184145427e958f20d01ba16765fcb40.svg";